// extracted by mini-css-extract-plugin
module.exports = {"container":"basestyles_container__2U73Z","inputWidth":"basestyles_inputWidth__3xOiL","headerWidth":"basestyles_headerWidth__1gd86"};